import { Logger } from 'src/utils/Logger';

export function formatPercentage(
  value: unknown,
  options?: { fractionDigits?: number; multiplyBy100?: boolean },
): string | undefined {
  const castedNumber = Number(value);
  if (isNaN(castedNumber)) {
    Logger.warn('Value is not a number for PERCENTAGE', { value });
    return;
  }

  const displayValue = options?.multiplyBy100 ? castedNumber * 100 : castedNumber;

  if (options?.fractionDigits !== undefined) {
    return `${displayValue.toFixed(options.fractionDigits)}%`;
  }

  return `${displayValue}%`;
}
